import { motion } from 'framer-motion';
import SearchContainer from '../common/SearchContainer';
import './HeroSearch.css';

function HeroSearch() {
  return (
    <div className="hero-search">
      <div className="hero-search-wrapper">
        <motion.div
          className="hero-search-text"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1>
            <span className="gradient-text"> One Click To </span> your Career. <span className="gradient-text"> Find Your&nbsp;</span> 
       
             <span className="highlight"> Fit.</span>
       
          </h1>
        </motion.div>

        <motion.div
          className="hero-search-container"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <SearchContainer variant="hero" />
        </motion.div>
      </div>
    </div>
  );
}

export default HeroSearch; 